import { Component, EventEmitter, Input, Output } from '@angular/core'
import { NgbDate } from '@ng-bootstrap/ng-bootstrap'
import * as moment from 'moment'

export interface DateRangePickerSelection {
  from: number
  to: number
}

@Component({
  selector: 'app-date-range-picker',
  templateUrl: './date-range-picker.component.html',
  styleUrls: ['./date-range-picker.component.scss'],
})
export class DateRangePickerComponent {
  @Input('selection')
  set setSelection(selection: DateRangePickerSelection) {
    setTimeout(() => {
      this.prepareDates(selection)
    })
  }

  @Input() local = false

  @Output() selectionChange = new EventEmitter<DateRangePickerSelection>()

  hoveredDate: NgbDate

  fromDate: NgbDate
  toDate: NgbDate

  onDateSelection(date: NgbDate) {
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date
    } else if (this.fromDate && !this.toDate && date.after(this.fromDate)) {
      this.toDate = date
    } else {
      this.toDate = null
      this.fromDate = date
    }

    if (this.fromDate && this.toDate) {
      setTimeout(() => {
        this.selectionChange.emit({
          from: this.toTimestamp(this.fromDate),
          to: this.toTimestamp(this.toDate),
        })
      })
    }
  }

  isHovered(date: NgbDate) {
    return (
      this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate)
    )
  }

  isInside(date: NgbDate) {
    return date.after(this.fromDate) && date.before(this.toDate)
  }

  isRange(date: NgbDate) {
    return date.equals(this.fromDate) || date.equals(this.toDate) || this.isInside(date) || this.isHovered(date)
  }

  private prepareDates(selection: DateRangePickerSelection) {
    this.fromDate = !selection || !selection.from ? null : this.fromTimestamp(selection.from)
    this.toDate = !selection || !selection.to ? null : this.fromTimestamp(selection.to)
  }

  private fromTimestamp(timestamp: number) {
    const m = (this.local ? moment : moment.utc)(timestamp * 1000)

    return NgbDate.from({
      day: m.date(),
      month: m.month() + 1,
      year: m.year(),
    })
  }

  private toTimestamp(date: NgbDate) {
    return (this.local ? moment : moment.utc)({
      year: date.year,
      month: date.month - 1,
      date: date.day,
    })
      .startOf('date')
      .unix()
  }
}
